import "./SoftwareSolutionsSection4.css";
import React from "react";
import phoneMockup from "../../../assets/Beykoy_Phone_Mockup.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SoftwareSolutionsSection4 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="tailored-section">
      <div className="container-softwaresection4">
        <figure className="mockup-container">
          <img
            src={phoneMockup}
            alt="Mobile application mockup"
            className="mockup-image"
          />
        </figure>

        <article className="text-container-softwaresection4">
          <header>
            <h2>
              {t("softwareSolutions.softwareSolutions4.heading1")} <br />
              <span className="highlight-softwaresection4">
                {t("softwareSolutions.softwareSolutions4.heading2")}
              </span>
            </h2>
          </header>
          <p>{t("softwareSolutions.softwareSolutions4.paragraph1")}</p>
          <p>{t("softwareSolutions.softwareSolutions4.paragraph2")}</p>
          <Link to={`/${lang}/Pricing`} onClick={scrollToTop} className="cta">
            <button className="learn-more">
              {t("softwareSolutions.softwareSolutions4.button")}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ background: "rgba(0, 0, 0, 0)" }}
              />
            </button>
          </Link>
        </article>
      </div>
    </section>
  );
};

export default SoftwareSolutionsSection4;
